import { render } from "./Part_NextworkButton.vue?vue&type=template&id=7634df8e&scoped=true"
import script from "./Part_NextworkButton.vue?vue&type=script&lang=js"
export * from "./Part_NextworkButton.vue?vue&type=script&lang=js"

import "./Part_NextworkButton.vue?vue&type=style&index=0&id=7634df8e&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7634df8e"]])

export default __exports__